import { useConfigStore } from 'shared/store/configSlice'
import { ColorPicker } from 'entities/ColorPicker'

export const ColorPickerTR = () => {
  const color = useConfigStore().config?.tableReservationConfig?.colour
  const updateTableReservationConfig = useConfigStore().updateTableReservationConfig

  return <ColorPicker color={color || ''} updateColorHandler={updateTableReservationConfig} />
}
